export default __webpack_public_path__ + "static/media/Avatar-9-noback.276ece78.png";